import { authRoles } from "app/auth";
import React from 'react'
const OwnerRegisterConfig = {
	settings: {
		layout: {
			config: {
				navbar: {
					display: false,
				},
				toolbar: {
					display: false,
				},
				footer: {
					display: false,
				},
				leftSidePanel: {
					display: false,
				},
				rightSidePanel: {
					display: false,
				},
			},
		},
	},
	auth: authRoles.onlyGuest,
	routes: [
		{
			path: '/owner/register',
			component: React.lazy(() => import('./OwnerRegister'))
		}
	]
};

export default OwnerRegisterConfig;
